<template>
  <v-container fluid :class="contactContainerClass">
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>
    <!-- 
    <template v-if="accountingCostsAddModalContainer">
      <v-dialog v-model="accountingCostsAddModal" persistent width="600">
        <AccountingCostsAdd @cancelled="onAccountingCostsAddCancelled" />
      </v-dialog>
    </template>

    <template v-if="accountingCostRecoupablesModalContainer">
      <v-dialog v-model="accountingCostRecoupablesModal" persistent width="1000">
        <CostRecoupables @cancelled="onCostRecoupablesCancelled" />
      </v-dialog>
    </template> -->

    <!-- <template v-if="accountingCostSplitAddModalContainer">
      <v-dialog v-model="accountingCostSplitAddModal" persistent width="500">
        <CostSplitAdd @cancelled="onCostSplitAddCancelled" />
      </v-dialog>
    </template> -->
  </v-container>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "./store";
import { childOfOrEqualDetails } from "./router/routes";
import { createModalMixin } from "../../dt-plugins/modal/modal.mixin";
import * as I18nActionTypes from "../../store/app/i18n/types";
// import AccountingCostsAdd from "./components/costs/add-new-cost.vue";
// import CostRecoupables from "./components/costs/cost-sidewindow/assign-project-recoupables";
//import CostSplitAdd from "./components/costs/cost-sidewindow/cost-split-add";
import { mapGetters } from "vuex";

export default {
  components: {
    // AccountingCostsAdd,
    // CostRecoupables,
    // CostSplitAdd
  },
  mounted() {
    this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
      "invoice",'label'
    ]);
  },
  mixins: [
    // createModalMixin("accountingCostsAdd"),
    // createModalMixin("accountingCostRecoupables"),
    // createModalMixin("accountingCostSplitAdd"),
  ],
  computed: {
    // ...mapGetters(storeNS, {
    // }),
    contactContainerClass: function () {
      return {
        "dt-module": true,
        inactive: childOfOrEqualDetails(this.$route),
      };
    },
  },
  methods: {
    onAccountingCostsAddCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },

    onCostRecoupablesCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },

    onCostSplitAddCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    //MARK: Methods
  },
};
</script>

